/* eslint-disable multiline-comment-style */
import { getNumStr, isEqualString } from '@/common/utils'

export enum EndTimeTypeEnum {

  /** 自定义 */
  CUSTOM = 1,

  /** 长期有效 */
  PERMANENT = 2
}

export enum StaffStatusEnum {

  /** 不限制 */
  NO_LIMIT = '-1',

  /** 在职 */
  IN_JOB = '2',

  /** 离职 */
  DIS_MISSION = '1'
}

/** NOTE: 后端实际数据结构为1 | 2, UI与后端数据结构不一致,所以使用1_x 前缀兼容接口和UI
 * 1_x: x代表下发周期的类型,例如 0是一次性下发
 *
 */
export enum BudgetFeeTypeFeEnum {

  /**  余额批次 */
  'BATCH' = '2',

  /** 预算津贴-循环下发 */
  'BUDGET_LOOP' = '1_1',

  /** 预算津贴-一次性下发 */
  'BUDGET_ONCE' = '1_0',
}

export enum BudgetFeeTypeEnum {
  /**  余额批次 */
  'BATCH' = 2,
  /** 预算津贴 */
  'BUDGET' = 1,
}

export enum BudgetFeeConfigTypeEnum {
  /**  用户输入 */
  'INPUT' = '1',
  /**  EXCEL/自定义 */
  'EXCEL' = '1001',
}

/** 将前端feeType转换为接口格式 */
export const transFeeType2Backend = (feeType?: BudgetFeeTypeFeEnum) => Number(String(feeType).split('_')[0])

/** 将接口feeType转换为前端格式 */
export const transFeeType2Fe = (feeType?: BudgetFeeTypeEnum, periodType?: number) => {
  if (isEqualString(feeType, BudgetFeeTypeEnum.BUDGET)) { // 预算下发
    if (isEqualString(periodType, 0)) { // 一次性下发
      return BudgetFeeTypeFeEnum.BUDGET_ONCE
    }
    return BudgetFeeTypeFeEnum.BUDGET_LOOP
  }
  return getNumStr(feeType) // 默认余额批次
}